import { Component, OnInit } from '@angular/core';
import { PostnewJob } from '../../services/job-section.service';
import { LoginService } from 'src/app/core/services/login.service';
import { Router } from '@angular/router';
import { JobProfilePostPreviewComponent } from 'src/app/modules/dashboard/modules/my-directory/pages/job-profile-post-preview/job-profile-post-preview.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-talent-enquiries',
  templateUrl: './talent-enquiries.component.html',
  styleUrls: ['./talent-enquiries.component.scss']
})
export class TalentEnquiriesComponent implements OnInit {

  constructor(private jobService: PostnewJob, private loginService: LoginService, private router: Router, private dialog: MatDialog,) { }
  loginDetails: any;
  myEnquiryAllList: any;
  // myEnquiryJob: any;
  openEnquiryAccordionId: string | null = null;
  enquiryData: any[];
  newMessage: string = '';
  openAccordionId: string | null = null;
  displayMessage: any[] = [];
  EditedMessageId: string = '';


  loaderMessage = true;
  loaderEnquiry = true;
  dataLoader = true;

  ngOnInit(): void {
    this.loginDetails = this.loginService.getLoginData();

    this.loadMoreEnquiries();


  }

  viewTalentProfile(talentId: string | number): void {

    this.dialog.open(JobProfilePostPreviewComponent, {
      width: '60%',
      panelClass: ['custom-modal'],
      data: { id: talentId }   // send only the id
    });
  }

  // viewJob(job: any): void {
  //   this.router.navigate(['/jobseek/jobdetails', job.id]);
  // }


  limit = 5;
  offset = 0;
  loading = false;
  endOfData = false;

  myEnquiryJob: any[] = [];

  loadMoreEnquiries(): void {

    if (this.loading || this.endOfData) return;

    this.loading = true;

    this.jobService.getMyEnquiryTalent(this.limit, this.offset).subscribe({
      next: (jobs) => {

        const enrichedJobs = jobs;

        if (enrichedJobs.length < this.limit) {
          this.endOfData = true;
        }

        this.myEnquiryJob = [...this.myEnquiryJob, ...enrichedJobs];        

        this.offset += this.limit;
        this.loading = false;
        this.dataLoader = false;

      },
      error: (err) => {
        console.error("Error fetching enquiry jobs:", err);
        this.loading = false;
         this.dataLoader = false;

      }
    });


  }

  // Enquiry
  EnquiryAcoordion(jobs: any): void {
    // Close the message accordion when opening the enquiry accordion
    this.openAccordionId = null;
    this.enquiryData = [];
    this.loaderEnquiry = true;

    this.openEnquiryAccordionId = this.openEnquiryAccordionId === jobs.id ? null : jobs.id;

    const jobID = jobs?.talent_id;
    const userId = jobs?.enquiry_from;

    this.jobService.getTalentEnquiry(jobID, userId).subscribe({
      next: (data) => {
        this.enquiryData = data;
        this.loaderEnquiry = false;
      },
      error: () => {
        this.loaderEnquiry = false;
      }
    });

  }

  messageAcordion(job: any): void {

    // Close the enquiry accordion when opening the message accordion
    this.openEnquiryAccordionId = null;

    this.loaderMessage = true;

    this.openAccordionId = this.openAccordionId === job.id ? null : job.id;
    this.newMessage = '';
    // Clear messages first
    this.displayMessage = [];

    this.getAllTalentMessage(job?.jobhirings_find_supplier?.id || job?.jobhirings_find_practice?.id, job?.id);

  }


  getAllTalentMessage(HireId: any, EnquiryId: any) {

    this.jobService
      .getTalentMessage(HireId, EnquiryId)
      .subscribe({
        next: (data) => {
          this.displayMessage = data;
          this.loaderMessage = false;
        },
        error: () => {
          this.loaderMessage = false;
        },
      });
  }



  // send message

  sendMessage(jobId: any): void {


    if (!this.newMessage.trim()) return; // Do not send empty messages

    // Applied Job Message
    const messages = {
      message: this.newMessage,
      enquiry_message_id_to: jobId?.id,
      message_from: this.loginDetails.id,
      talent_id: jobId.job_profiles?.id,
    };

    this.jobService.addTalentMessage(messages);

    this.newMessage = ''; // Clear the input box
  }


  deleteMessage(messageId: string): void {

    this.jobService.deleteTalentMessage(messageId).then(() => {

    }).catch((err) => {
      console.error("Error deleting message:", err);
    })
  }

  editMessage(message: any): void {
    this.newMessage = message.message;
    this.EditedMessageId = message.id;
  }

  UpdateMessage(editId: any): void {

    const UpdateMessage = {
      id: editId,
      message: this.newMessage,
      updated_at: new Date().toISOString().replace('Z', '+00:00'),
    }

    this.jobService.editTalentMessages(UpdateMessage.id, UpdateMessage.message, UpdateMessage.updated_at).then(() => {
      this.EditedMessageId = '';
      this.newMessage = '';
    })

  }

  trackByJobId(index: number, job: any): string {

    return job.id;
  }

  getInitial(name: string | undefined | null): string {
    if (!name) return '';
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2); // max 2 initials
  }

}

